import * as actionTypes from "./actionTypes";
import * as actions from './index';
import * as eTypes from 'Flow2/components/Ecommerce/EcommerceConfig/EcommerceTypes';

export const updateEcommerceObjectsSuccess = (data) => {
    return {
        type: actionTypes.ECOMMERCE_UPDATE_ECOMMERCEOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateEcommerceObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateEcommerceObjectsSuccess(obj));
    }
}

export const setInitShareObjects = () => {
    return {
        type: actionTypes.ECOMMERCE_SET_INIT_ECOMMERCEOBJECTS
    }
}

export const getList = async ({ list, itemlist }) => {
    let newList = [];
    for (let i = 0; i < list.length; i++) {
        let found;
        let li = list[i];
        let tmp;
        if (itemlist && itemlist.length) found = itemlist.find(entry => entry.id == li.spots_id)
        if (found && found.data && found.data.metadata) tmp = found;
        else {
            try {
                const res = await window.flow.sdkGetItem(li.spots_id);
                tmp = res;
            } catch (err) { console.log("LOGS: getList err", err) }
        }
        if (tmp && tmp.data) {
            let nShows = [];
            if (li.shows) {
                try {
                    nShows = JSON.parse(li.shows);
                } catch (err) { 
                    //console.log("LOGS: getList err", err) 
                }
            }

            newList.push({
                metadata: { fields: { ...tmp.data.metadata.fields } }, ...li,
                id: tmp.data.id, rentelid: li.id, shows: nShows
            });
        }
    }
    return newList;
}

export const getShowDates = ({ newCartList }) => {
    let itemsShowsObj = {};
    if (newCartList && newCartList.length) {
        newCartList.forEach(item => {
            itemsShowsObj[item.id] = {};
            if (item.showdates && item.showdates.length) {
                item.showdates.forEach((date, idx) => {
                    itemsShowsObj[item.id][date] = item.shows[idx] || 1;
                })
            }
        })
    }
    return { itemsShowsObj };
}


export const getOldRentList = async ({res}) => {
     let rentList = [];
     let itemList = [];
    for (let i = 0; i < res.data.length; i++) {
        let elem = res.data[i];
        let userRes = await window.flow.crmSearchUsers({ 'users.id': elem.sdkusers_id });
            let user;
            if (userRes && userRes.data) user = userRes.data[0];
            let newElem = { ...elem, user, data: [] };
            if (elem && elem.rentels) {
                let list = elem.rentels;
                if (list && list.length) {
                    let newList = await getList({ list, itemList });
                    if (newList) newElem.data = newList;
                }
            }

        rentList.push(newElem);
    }
    return rentList;
}

export const getRentList = ({res}) => {
    let rentList = [];
    for (let i = 0; i < res.data.length; i++) {
        let elem = res.data[i];
        let data = [];
        let user = {};
        for (let j in elem){
            if(j.includes(eTypes. RENTEDIT_U)) user[j] = elem[j];
        }
        if(elem && elem.rentels && elem.rentels.length){
            data = elem.rentels.map(entry => {
                let newEntry = {...entry, metadata: {fields: {...entry.item}}, rentelid: entry.id};
                return newEntry;
            });
        }
        let newElem = {...elem, user, data};
        rentList.push(newElem);
    }
    return rentList;
}

export const searchGetFeRents = (obj) => {
    let searchObj = { ...obj, limit: 15, offset: 3 }
    // if (rentid) searchObj = { fields: { rentid }, limit, offset };
    return async (dispatch, getState) => {
        try {
            dispatch(actions.updateEcommerceObjects({ loading: true }));
            console.log("LOGS: sdkVlSearchRents searchObj", searchObj);
            const res = await window.flow.sdkVlSearchRents(searchObj);
            if (res) {
                console.log("LOGS: searchGetFeRents res", res);
                if (res && res.data && res.data.length) {
                    let rentList = getRentList({res});
                    //let rentList = await getOldRentList({res});
                    if (rentList && rentList.length) {
                        dispatch(actions.updateEcommerceObjects({ rentList: rentList, loading: false }));
                    }
                }
            }
            dispatch(actions.updateEcommerceObjects({ loading: false }));
        } catch (err) {
            console.log("LOGS: searchFeRents err", err);
            dispatch(actions.updateEcommerceObjects({ loading: false }));
        }
    }
}

export const refreshRent = ({res, dispatch}) => {
    console.log("LOGS: refreshRent res", res);
     if (res && res.data) {
            let parsedrentels = [];
            let data = res.data;
            if(res.data.rent) data = res.data.rent;
            if (data.parsedrentels && data.parsedrentels.length) {
                parsedrentels = data.parsedrentels.map(el => {
                    return { ...el, item: { metadata: { fields: { ...el.rentel.item } } } }
                })
            }
            dispatch(actions.updateEcommerceObjects({ 
                currentRent: { ...data, parsedrentels }, loading: false }));
        }
}

export const getFeRent = ({ rentid }) => {

    return async (dispatch, getState) => {
        try {
            dispatch(actions.updateEcommerceObjects({ loading: true }));
            let res;
            if (rentid) {
                console.log("LOGS: sdkVlGetRent rentid", rentid);
                res = await window.flow.sdkVlGetRent(rentid);
                if(res && res.data) refreshRent({res, dispatch});
                else console.log("LOGS: LAMTEST100 something went wrong!!!");
            }
            dispatch(actions.updateEcommerceObjects({ loading: false }));
        } catch (err) {
            console.log("LOGS:sdkVlGetRent err", err);
            dispatch(actions.updateEcommerceObjects({ loading: false }));
        }
    }
}

//sdkVlEditRent / sdkVlEditRentel
export const editFeRent = (obj) => {
    return async (dispatch) => {
        try {
            if (obj) {
                console.log("LOGS: editFeRentel  obj", obj);
                const res = await window.flow.sdkVlEditRent(obj);
                if(res && res.data) refreshRent({res, dispatch});
                else console.log("LOGS: LAMTEST100 something went wrong!!!");
            }
        } catch (err) {
            console.log("LOGS: LAMTEST editFeRentel err", err);
        }
    }
}


export const getBlocks = ({clipId}) => {
    return async (dispatch, getState) => {
        try {
            if (clipId) {
                console.log("LOGS: getBlocks  clipId", clipId);
                const res = await window.flow.sdkFeReGetBlocksByClids(clipId);
                if (res && res.data) {
                    console.log("LOGS: getBlocks res", res);
                     let curBlocksObj = getState().ecommerce.ecommerceObjects.curBlocksObj;
                     curBlocksObj = {...curBlocksObj, ...res.data};
                     dispatch(actions.updateEcommerceObjects({curBlocksObj}));
                }
            }
        } catch (err) {
            console.log("LOGS: getBlockserr", err);
        }
    }
}

export const replaceItem = ({priref}) => {
    console.log("LOGS: LAMTEST100 replaceItem  priref",priref);
    return async (dispatch) => {
        try {
            if (priref) {
                console.log("LOGS: replaceItem  priref",priref);
                const res = await window.flow.sdkVlGetReplaceItem(priref)
                if(res && res.data){
                     console.log("LOGS: replaceItem  res", res);
                }
                else console.log("LOGS: LAMTEST100 something went wrong!!!");
            }
        } catch (err) {
            console.log("LOGS: LAMTEST editFeRentel err", err);
        }
    }
}
